import React from 'react';
import Link from 'gatsby-link'

const SiteMap = (props) => {
  return (
    <div className="sitemap">
    	<ul>
            <li><Link to="/" style={{
                color: '#F6F6F6',
                textDecoration: 'none',
              }} >Inicio</Link></li>
            <li><Link to="/services/" style={{
                color: '#F6F6F6',
                textDecoration: 'none',
              }} >Servicios</Link></li>
            <li><Link to="/about/" style={{
                color: '#F6F6F6',
                textDecoration: 'none',
              }} >Nosotros</Link></li>
            <li><Link to="/contact/" style={{
                color: '#F6F6F6',
                textDecoration: 'none',
              }} >Contacto</Link></li>
            <li><Link to="/blog/" style={{
                color: '#F6F6F6',
                textDecoration: 'none',
              }} >Blog</Link></li>
            {/*<li><Link to="/about" style={{
                          color: '#F6F6F6',
                          textDecoration: 'none',
                        }} >Careers</Link></li>*/}
        </ul>
    </div>
  )
}

export default SiteMap;


// WEBPACK FOOTER //
// ./src/components/sitemap.js